<template>
  <v-container>
    <v-form ref="deploy-date">
      <v-col cols="12" md="6">
        <label class="datepicker-label">Trial Date:</label>
        <Datepicker
          v-model="selectedDate"
          uid="search-deploy-date"
          format="yyyy-MM-dd"
          :enable-time-picker="false"
          placeholder="deployment date"
          type="date"
          clearable
          menu-class="w-96"
        />
        <v-tooltip
          activator="#dp-input-search-deploy-date"
          location="top"
          open-delay="300"
        >
          Select deployment date to see a list of locations.
        </v-tooltip>
      </v-col>
    </v-form>
    <Observation
      v-if="hasRecords"
      :selectedDate="selectedDate"
      v-on="handler"
    />
  </v-container>
</template>

<script>
import { support } from "search-observe-app";
import Datepicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import Observation from "@/components/Observation";
export default {
  name: "Deploy-Form",
  components: { Datepicker, Observation },
  props: {
    datatype: String,
  },
  data() {
    return {
      handler: {},
      selectedDate: new Date(),
      required: [(v) => !!v || "Required"],
    };
  },
  computed: {
    dbName() {
      return this.$store.getters["shared/dbName"];
    },
    access_level() {
      return this.$store.getters["shared/access_level"];
    },
    databaseSet() {
      return !(
        this.dbName == undefined ||
        this.dbName == null ||
        this.dbName == ""
      );
    },
    hasRecords() {
      return this.$store.getters["shared/dataTables"]["decoy_trial"].length > 0;
    },
  },
  async mounted() {
    support.startWatch();
    this.kickback();
    this.$watch(
      "dbName",
      () => {
        this.kickback();
      },
      { deep: true }
    );
    this.$watch(
      "access_level",
      () => {
        this.kickback();
      },
      { deep: true }
    );

    //Need to load data
    support.getApiData(
      `${this.$store.getters["shared/dbName"]}/public/decoy_trial/`,
      "decoy_trial",
      "dataTables"
    );
    support.getApiData(
      `${this.$store.getters["shared/dbName"]}/public/survey_photo_decoy/`,
      "survey_photo_decoy",
      "dataTables"
    );
  },
  methods: {
    asBoolean(b) {
      return support.asBoolean(b);
    },
    kickback() {
      if (!this.databaseSet || this.access_level !== "admin") {
        this.$router.push({ name: "home" });
      }
    },
  },
};
</script>
